export enum MapMenus {
  General = 'general',
  Meteo = 'meteo',
  Routing = 'routing',
  Routes = 'routes',
}
